import {
  CreateGUFAddRealisedInstallationTask,
  EditGUFAddRealisedInstallationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for RealisedScreen within a RealisedWell
 */
export const realisedScreenSchema = addSchema<
  (
    | CreateGUFAddRealisedInstallationTask
    | EditGUFAddRealisedInstallationTask
  )["sourcedocumentData"]["realisedWells"][number]["realisedScreens"]
>({
  type: "array",
  title: "Gerealiseerde filters",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde filter",
    required: ["realisedScreenId", "screenType", "topScreenDepth", "length"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "realisedScreenId",
        "screenType",
        "topScreenDepth",
        "length",
        "realisedScreenPos",
        "segments",
      ]),
      // geometryType maps to realisedGeometryType in the schema ("Point"|"Curve")
      geometryType: pickGufPrimitiveLibraryFields(["realisedGeometryType"]).realisedGeometryType,
    },
  },
});
